<mat-nav-list class="mat-nav">
  @for (menuItem of menus; track menuItem) {
    <div class="list-of-item">
      @if (menuItem.children && menuItem.children.length > 0) {
        <span>
          <mat-expansion-panel [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
              {{ menuItem.name }}
            </mat-expansion-panel-header>
            @for (child of menuItem.children; track child) {
              <mat-nav-list>
                <a mat-list-item [routerLink]="[menuItem.link]" routerLinkActive="active" (click)="route(child)">
                  <!-- <mat-icon *ngIf="child.hasIcon">{{ child.icon }}</mat-icon> -->
                  <img [src]="child.icon" alt="">
                  <div>{{ child.name }}</div>
                </a>
              </mat-nav-list>
            }
          </mat-expansion-panel>
        </span>
      }
      @if (!menuItem.children || menuItem.children.length === 0) {
        <span>
          <mat-list-item [routerLink]="[menuItem.link]" routerLinkActive="active">
            <!-- <mat-icon *ngIf="menuItem.hasIcon">{{ menuItem.icon }}</mat-icon> -->
            <img [src]="menuItem.icon" alt="">
            <div>{{ menuItem.name }}</div>
          </mat-list-item>
        </span>
      }
    </div>
  }
</mat-nav-list>